import React from 'react';
import { Box } from '@mui/material';
import { marketingColors as C, marketingFonts as F } from '../../theme_landing_page';

const CheckMark: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={C.accent} strokeWidth={3} strokeLinecap="round" strokeLinejoin="round">
    <path d="m5 12 5 5L20 7" />
  </svg>
);

const KeyTakeaways: React.FC<{ items: string[]; dark?: boolean }> = ({ items, dark = false }) => {
  if (!items.length) return null;
  return (
    <Box
      sx={{
        background: dark ? C.ink : C.tintBlue,
        color: dark ? C.white : 'inherit',
        border: dark ? 'none' : '1px solid rgba(0,84,249,0.15)',
        borderRadius: '20px',
        padding: '28px 30px',
        marginBottom: '44px',
      }}
    >
      <Box sx={{ fontFamily: F.display, fontSize: 24, marginBottom: '16px', color: dark ? C.white : 'inherit' }}>Key takeaways</Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {items.map((k) => (
          <Box key={k} sx={{ display: 'flex', gap: '12px', alignItems: 'flex-start', fontSize: 15.5, color: dark ? 'rgba(255,255,255,0.85)' : C.proseText, lineHeight: 1.5 }}>
            <Box sx={{ marginTop: '4px', flex: 'none' }}>
              <CheckMark />
            </Box>
            {k}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default KeyTakeaways;
